var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.022,
    y: 1.522,
    width: 47.955,
    height: 47.955,
    rx: 23.978,
    fill: "#EF4444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.022,
    y: 1.522,
    width: 47.955,
    height: 47.955,
    rx: 23.978,
    stroke: "#000",
    strokeWidth: 3.045
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning_svg__clip0_5697_20846)",
    stroke: "#fff",
    strokeWidth: 3.265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 36.385c6.011 0 10.884-4.873 10.884-10.885 0-6.01-4.873-10.884-10.884-10.884S15.116 19.49 15.116 25.5c0 6.012 4.873 10.885 10.884 10.885zM26 29.854h.011M26 21.146V25.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning_svg__clip0_5697_20846"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12.94 12.439)",
    d: "M0 0h26.122v26.122H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/warning.6c14bc65.svg";
export { SvgWarning as ReactComponent };